import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = {
  upsertPlayer: (name) => axios.post(`${API}/players`, { name }).then((r) => r.data),
  shop: () => axios.get(`${API}/shop`).then((r) => r.data),
  checkout: (name, lookup_key) => axios.post(`${API}/payments/checkout`, { name, lookup_key, origin_url: window.location.origin }).then((r) => r.data),
  paymentStatus: (id) => axios.get(`${API}/payments/status/${id}`).then((r) => r.data),
  buy: (name, item_id) => axios.post(`${API}/players/${encodeURIComponent(name)}/buy`, { item_id }).then((r) => r.data),
  equip: (name, skin) => axios.post(`${API}/players/${encodeURIComponent(name)}/equip`, { skin }).then((r) => r.data),
  daily: () => axios.get(`${API}/daily`).then((r) => r.data),
  submitDaily: (payload) => axios.post(`${API}/daily/scores`, payload).then((r) => r.data),
  dailyLeaderboard: () => axios.get(`${API}/daily/leaderboard`).then((r) => r.data),
  startRun: (name) => axios.post(`${API}/players/${encodeURIComponent(name)}/start-run`).then((r) => r.data),
  addAchievements: (name, ids) => axios.post(`${API}/players/${encodeURIComponent(name)}/achievements`, { ids }).then((r) => r.data),
  addBestiary: (name, ids) => axios.post(`${API}/players/${encodeURIComponent(name)}/bestiary`, { ids }).then((r) => r.data),
  submitScore: (payload) => axios.post(`${API}/scores`, payload).then((r) => r.data),
  leaderboard: () => axios.get(`${API}/leaderboard?limit=20`).then((r) => r.data),
};
